import apiClient from "@utils/axios.utils"; // Ajustez le chemin d'importation si nécessaire

export interface CampaignStatus {
    active: boolean;
    // Ajoutez d'autres propriétés retournées par l'API si nécessaire
}

export const getCampaignStatus = async (): Promise<CampaignStatus> => {
    try {
        const response = await apiClient.get<CampaignStatus>("/campaign/status");
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération du status de la campagne :", error);
        throw error;
    }
};